import feCore from "../../../node_modules/am-tax-fe-core/dist/locales/en/am-tax-fe-core.json";

import deliverables from "./Deliverables.json";
import documents from "./Documents.json";
import requestPage from "./EngagementRequestPage.json";
import leftNav from "./LeftNav.json";
import requestForm from "./RequestForm.json";
import requestsPage from "./RequestsPage.json";

// namespace structure used with useTranslation hook, ie.
// const { t } = useTranslation("LeftNav");

export default {
    "am-tax-fe-core": { ...feCore },
    Deliverables: { ...deliverables },
    Documents: { ...documents },
    EngagementRequestPage: { ...requestPage },
    LeftNav: { ...leftNav },
    RequestForm: { ...requestForm },
    RequestsPage: { ...requestsPage },
};
